import * as React from 'react';
import { SlackSquareOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import './ErrorPage.css';

import { GRABX_SLACK_CHANNEL } from '@/constants';

const ErrorPage: React.FC = () => (
  <div className="not-found-page__container">
    <div className="not-found-page__content">
      <h1>404 Not Found</h1>
      <p>This is probably not what your&apos;re looking for..</p>
      <Link to="/">Return to home page</Link>
      <div className="not-found-page__need-help-block">
        Need help? Ask on&nbsp;
        <a href={GRABX_SLACK_CHANNEL} target="_blank" rel="noreferrer">
          <SlackSquareOutlined {...({} as any)} />
          grab-x
        </a>
        &nbsp;slack channel
      </div>
    </div>
  </div>
);

export default ErrorPage;
